<template>
  <div class="empty-new" :style="wrapStyle">
    <div class="empty-news-title">
      <slot name="title">{{ title }}</slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EmptyNew',
  props: {
    title: {
      type: String,
      default: '',
    },
    wrapStyle: {
      type: Object,
    },
  },
};
</script>
<style lang="scss" scoped>
.empty-new {
  background: url('~@/assets/images/common/empty@2x.png') no-repeat center center/484px 294px;
  height: 294px;
}
.empty-news-title {
  color: #999999;
  line-height: 20px;
  text-align: center;
  padding-top: 246px;
}
</style>
